export namespace LgvFormlyModel {

    export interface Properties {
        label?: string,
        placeholder?: string,
        required?: boolean,
        customProps?: any[],
        options?: any[],
        icon?: string,
        maxLength?: number;
        minLength?: number;
        lgvSectionId?:string;
        hideForPreQual?:boolean;
        hideForFullLoanApp?:boolean;
    }

    export interface Object {
        key?: string,
        type?: string,
        props?: Properties,
        fieldGroupClassName?: string,
        fieldGroup?: Object[];
        fieldArray?: Object;
        className?: string,
        template?: string,
        expressions?: any,
        validators?: any,
        hooks?:any
    }

    export interface NavigationNode {
        parent?: Object,
        appObj: Object
    }

export class FieldStatus {
    key: string;
    label: string;
    defaultVal: string;
    currentVal: string;
    currentLabel: string;
    hidden: boolean;
    required: boolean;
    invalid?: boolean;
    changed: boolean;
    arrayItems: any[];
}

    export enum FormSectionStatus {
        NotStarted = 'NotStarted',
        Started = 'Started',
        Complete = 'Complete'
    }

    export class GroupSummary {
        id?:string;
        isHidden?:boolean;
        sectionStatus: FormSectionStatus;
        numFields: number;
        numChanged: number;
        numRequiredRemaining: number;
        numRequired: number;
        fieldList: FieldStatus[];
        refreshedInApp?: boolean;
    }

    export class UserConfirmedNoItem{
        changeSummaryKey:string;
        modelKey:string;
    }
}